import React, { useState, useEffect } from "react";
import { database } from "../../firebaseConfig";
import { ref, get, set } from "firebase/database";
import "./FooterConfigEditor.css";

const FooterConfigEditor = () => {
    const [footerConfig, setFooterConfig] = useState({
        aboutUsEnabled: true,
        contactDetailsEnabled: true,
        enquireFormEnabled: true,
        showLocationEnabled: true,
        locateUs: "Marriott:\ngokak\n\n+91-1234567890\n+91-1234567890",
        backgroundColor: "#ffffff", // New background color field
    });

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchFooterConfig = async () => {
            try {
                const snapshot = await get(ref(database, "footerConfig"));
                if (snapshot.exists()) {
                    setFooterConfig(snapshot.val());
                }
            } catch (error) {
                console.error("Error fetching footer config:", error);
            }
            setLoading(false);
        };
        fetchFooterConfig();
    }, []);

    const handleSave = async () => {
        try {
            await set(ref(database, "footerConfig"), footerConfig);
            alert("Footer configuration saved successfully!");
        } catch (error) {
            console.error("Error saving footer config:", error);
            alert("Error saving footer config.");
        }
    };

    if (loading) return <p>Loading Footer Config...</p>;

    return (
        <div className="footer-config-editor">
            <h2>Footer Configuration</h2>

            <div className="form-group">
                <label>
                    <input
                        type="checkbox"
                        checked={footerConfig.aboutUsEnabled}
                        onChange={(e) =>
                            setFooterConfig((prev) => ({
                                ...prev,
                                aboutUsEnabled: e.target.checked,
                            }))
                        }
                    />
                    Enable About Us Section
                </label>
            </div>

            <div className="form-group">
                <label>
                    <input
                        type="checkbox"
                        checked={footerConfig.contactDetailsEnabled}
                        onChange={(e) =>
                            setFooterConfig((prev) => ({
                                ...prev,
                                contactDetailsEnabled: e.target.checked,
                            }))
                        }
                    />
                    Enable Contact Details
                </label>
            </div>

            <div className="form-group">
                <label>
                    <input
                        type="checkbox"
                        checked={footerConfig.enquireFormEnabled}
                        onChange={(e) =>
                            setFooterConfig((prev) => ({
                                ...prev,
                                enquireFormEnabled: e.target.checked,
                            }))
                        }
                    />
                    Enable Inquiry Form
                </label>
            </div>

            <div className="form-group">
                <label>
                    <input
                        type="checkbox"
                        checked={footerConfig.showLocationEnabled}
                        onChange={(e) =>
                            setFooterConfig((prev) => ({
                                ...prev,
                                showLocationEnabled: e.target.checked,
                            }))
                        }
                    />
                    Show Location
                </label>
            </div>

            <div className="form-group">
                <label>Locate Us Data:</label>
                <textarea
                    value={footerConfig.locateUs}
                    onChange={(e) =>
                        setFooterConfig((prev) => ({
                            ...prev,
                            locateUs: e.target.value,
                        }))
                    }
                    rows="4"
                    placeholder="Enter address and contact details for Locate Us section"
                />
            </div>

            <div className="form-group">
                <label>Footer Background Color:</label>
                <input
                    type="color"
                    value={footerConfig.backgroundColor}
                    onChange={(e) =>
                        setFooterConfig((prev) => ({
                            ...prev,
                            backgroundColor: e.target.value,
                        }))
                    }
                />
            </div>
            <button onClick={handleSave}>Save Footer Config</button>
        </div>
    );
};

export default FooterConfigEditor;
